import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'

import Alert from '@material-ui/lab/Alert'

import {
  getFullScreenById,
  getFullScreenUser,
  pollFullScreenStart,
  pollFullScreenStop
} from 'common/actions/fullscreen'
import { getSystemsRaw } from 'common/selectors/systems'
import { getUsers } from 'common/selectors/entities'
import { getError, getIsSubmitting, getIsLoaded, getIsDataLoaded } from '../selectors'
import styles from '../../Login/components/LoginForm/LoginForm.module.scss'
import FullScreenView from '../components/FullScreenView/FullScreenView'

const FullScreenLinkContainer = props => {
  const {
    routeParams,
    getFullScreenById,
    pollFullScreenStart,
    getFullScreenUser,
    isLoaded,
    error,
    translate,
    systems,
    users
  } = props

  useEffect(() => {
    getFullScreenUser(routeParams.id)
    pollFullScreenStart(routeParams.id)
  }, [getFullScreenById, routeParams.id])

  if (!isLoaded) {
    return <div>{translate('loading')} ...</div>
  }

  if (error) {
    let message = translate('submitErrors.unknown')
    if (error.res.status === 404) {
      message = translate('submitErrors.channelNotFound')
    } else if (error.res.status === 403) {
      message = translate('submitErrors.channelForbidden')
    }

    return (
      <Alert
        severity='error'
        className={styles.error}
      >
        {message}
      </Alert>
    )
  }

  const systemsJS = []
  systems.toArray().map(s => systemsJS.push(s.toJS()))
  const system = systemsJS[0]
  if (!system) return null
  const user = users?.toJS()[Object.keys(users.toJS())[0]]

  return (
    <FullScreenView
      system={system}
      data={system.data}
      translate={translate}
      screenId={routeParams.id}
      user={user}
    />
  )
}

FullScreenLinkContainer.propTypes = {
  routeParams: PropTypes.any,
  error: PropTypes.any,
  isLoaded: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
  getFullScreenById: PropTypes.func.isRequired,
  pollFullScreenStart: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  systems: getSystemsRaw(state),
  error: getError(state),
  isSubmitting: getIsSubmitting(state),
  isLoaded: getIsLoaded(state),
  isDataLoaded: getIsDataLoaded(state),
  users: getUsers(state)
})

const mapActionsToProps = {
  getFullScreenById,
  pollFullScreenStart,
  pollFullScreenStop,
  getFullScreenUser
}

export default withLocalize(connect(mapStateToProps, mapActionsToProps)(FullScreenLinkContainer))
